// ======================================================================
// File Name       : ServiceLoginSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Button, FormControl, Form, Row } from 'react-bootstrap';
import CustomButton from './button/CustomButton';

class ServiceLoginSearch extends React.Component {
  render() {
    return (
      <Col sm={12}>
        <h3 className='padding-10'>検索する項目を指定してください</h3>
        <Form className='form-horizontal'>
          <Form.Group className="form-info">
            <Col sm={2} as={Form.Label}>サービス名</Col>
            <Col sm={5}>
              <FormControl
                type="text"
                name="serviceName"
                maxLength="256"
                onChange={this.props.onHandleChangeTextInput}
              />
            </Col>
            <Col sm={2} className='padding-left-15'>
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                handleClick={this.props.onHandleSearchBtn}
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        </Form>
      </Col>
    );
  }
}

export default ServiceLoginSearch;
